// test242
(242 && 0);
